import { Component } from '@angular/core';
import {environment} from "@environment";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  contactMail: string = environment.contactMail;
}
